import React from 'react'
import { Box, Button, Chip, Typography } from '@mui/material'

const TIER_DISPLAY = [
  { key: 'excellent', label: 'Excellent', backgroundColor: '#4caf50', color: '#fff' },
  { key: 'strong', label: 'Strong', backgroundColor: '#2196f3', color: '#fff' },
  { key: 'good', label: 'Good', backgroundColor: '#ff9800', color: '#fff' },
]

const KioskThankYouStep = ({ wizardData, onStartOver }) => {
  const matchCounts = wizardData.matchCounts || {}
  const totalMatches = matchCounts.total || 0

  return (
    <Box sx={{ textAlign: 'center', py: 6 }}>
      <Typography variant='h4' gutterBottom>
        Your job is live!
      </Typography>

      {totalMatches > 0 ? (
        <>
          <Typography variant='h6' sx={{ mb: 3 }}>
            You already have candidate matches
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap', mb: 3 }}>
            {TIER_DISPLAY.map(tier => {
              const count = matchCounts[tier.key] || 0
              if (count === 0) return null
              return (
                <Chip
                  key={tier.key}
                  label={`${count} ${tier.label}`}
                  sx={{ backgroundColor: tier.backgroundColor, color: tier.color }}
                  size='medium'
                />
              )
            })}
          </Box>
          <Typography variant='body1' color='text.secondary' sx={{ mb: 4, maxWidth: 520, mx: 'auto' }}>
            Completing the AAPPR scavenger hunt? We'll email you one matched candidate now.
            Want to see all {totalMatches}? Schedule a quick demo and get full access to your matches.
          </Typography>
        </>
      ) : (
        <Typography variant='body1' color='text.secondary' sx={{ mb: 4, maxWidth: 520, mx: 'auto' }}>
          We're searching for candidates that match your job and will reach out as soon as we find them.
          Schedule a demo to see everything MyStethi can do for your recruiting pipeline.
        </Typography>
      )}

      <Button variant='contained' onClick={onStartOver}>
        Start Over
      </Button>
    </Box>
  )
}

export default KioskThankYouStep
